import { useTranslation } from 'react-i18next';

export default function SuccessErrorMsg({ ToastContainer }) {
    const { i18n } = useTranslation();
    return (
        <ToastContainer
            newestOnTop={true}
            position={i18n.language === "ar" ? "top-left" : "top-right"}
            pauseOnFocusLoss
            pauseOnHover
            theme="light"
        />
    )
}

